import { hubEventTypes, signalRRecconectInterval, customEventTypes } from "./constants.js";
import { v4 } from 'uuid';
class EventDispatcher {
    #hubConnection;
    subscrubers = [];

    init(token) {
        if (!this.#hubConnection) {
            this.#hubConnection = new signalR.HubConnectionBuilder()
                .withUrl('/event')
                .withAutomaticReconnect({
                    nextRetryDelayInMilliseconds: () => {
                        return signalRRecconectInterval;
                    }
                })
                .build();

            this.#hubConnection.start()
                .then(() => {
                    this.#subscrubeToHubEvents();
                })
                .catch((err) => {
                    console.error('SignalR Init Error:');
                    console.error(err);
                });
            this.#hubConnection.onreconnected(async () => {
                this.#subscrubeToHubEvents();
            });
        }

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this.invokeEvent(customEventTypes.onReturnToPage);
            }
        });
    }

    subscrubeToEvent(eventType, func) {
        const id = v4();
        this.subscrubers.push({
            id: id,
            type: eventType,
            func: func
        });
        return id;
    }

    unsubscrubeFromEvent(id) {
        this.subscrubers = this.subscrubers.filter(s => s.id !== id);
    }

    invokeEvent(eventType, params) {
        this.subscrubers.filter(s => s.type === eventType).forEach(s => s.func(params));
    }

    #subscrubeToHubEvents() {
        Object.keys(hubEventTypes).forEach(key => {
            if (key !== 'missedMessages') {
                this.#hubConnection.on(hubEventTypes[key], async (params) => {
                    this.invokeEvent(hubEventTypes[key], params?.messageData);
                });
            }
        });
        this.#hubConnection.on(hubEventTypes.missedMessages, (params) => {
            params.messageData.forEach(data => this.invokeEvent(data.eventType, data.message.messageData));
        });
    }
}

export const eventDispatcher = new EventDispatcher();